<template>

	<div id="createOrUpdateModalForClient">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left" v-if="this.mode=='create'">
				{{ $t('client.addClient') }}
			</h4>
			<h4 class="pull-left" v-else>
				{{ $t('client.update-client') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<p v-if="refInputNotFilled" style="color: red;">{{$t('please-title')}}</p>

		<div class="row top">
			<div class="col-sm-6">

				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<label class="lebeltop">
						<span class="redStar">
											*
										</span>{{$t('employees.create.first-name')}}</label>

					<b-form-input style="width: 100%"
								  :placeholder="$t('client.create.first-name')" size="sm"
								  type="text"
								  autocomplete="off"
								  id="firstName"
								  ref="clientNameRef"
								  v-model="itemLocalClient.firstName"/>
				</b-form-group>
			</div>
			<div class="col-sm-6">
				<b-form-group
					label-size="sm"
					class="required"
					label-for="lastName">
					<label class="lebeltop">
						<span class="redStar">
											*
										</span>{{$t('employees.create.last-name')}}</label>

					<b-form-input size="sm" :placeholder="$t('employees.create.last-name')"
								  type="text"
								  id="lastName"
								  autocomplete="off"
								  v-model="itemLocalClient.lastName"/>
				</b-form-group>
			</div>
			<!--			<div class="col-sm-4">-->
			<!--				<b-form-group-->
			<!--					label-size="sm"-->
			<!--					label-for="refName">-->
			<!--					<label class="lebeltop">{{$t('client.create.middle-name')}}</label>-->
			<!--					<b-form-input size="sm" :placeholder="$t('employees.create.middle-name')"-->
			<!--								  type="text"-->
			<!--								  autocomplete="off"-->
			<!--								  id="middleName"-->
			<!--								  v-model="itemLocalClient.middleName"/>-->
			<!--				</b-form-group>-->
			<!--			</div>-->
		</div>
		<div class="row top">
			<!--			<div class="col-sm-4">-->
			<!--				<b-form-group-->
			<!--					label-size="sm"-->
			<!--					label-for="refName">-->
			<!--					<label class="lebeltop">-->
			<!--						{{$t('client.create.memberCardDiscount')}}</label>-->
			<!--					<b-form-input size="sm" :placeholder="$t('client.create.memberCardDiscount')"-->
			<!--								  type="text"-->
			<!--								  autocomplete="off"-->
			<!--								  id="memberCardDiscount"-->
			<!--								  v-model="itemLocalClient.memberCardDiscount"/>-->
			<!--				</b-form-group>-->
			<!--			</div>-->

			<!-- <div class="col-sm-6">
				<b-form-group
					label-size="sm"
					label-for="refName">
					<label class="lebeltop"><span class="redStar">
											*
										</span>Карта №</label>
					<b-input-group
						size="sm"
						class="mb-3"
					>
						<b-form-input size="sm" placeholder="Карта №"
									  type="text"
									  id="memberCard"
									  autocomplete="off"
									  v-model="itemLocalClient.memberCard"/>
						<b-input-group-append>
							<b-button size="sm" text="Button" variant="success"
									  @click.prevent="generateMemberCardFunc">
								<i class="fa fa-refresh"></i>
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
			</div> -->

			<div class="col-sm-6">
				<b-form-group
					style="font-size: 12px;padding-top: 3px"
					id="exampleInputGroup3"
					label-for="refCode"
					class="required"
				>
					<label class="lebeltop">
										{{$t('client.create.gender')}}</label>
					<b-form-select v-model="itemLocalClient.gender"
								   :plain="false"
								   size="sm"
								   :required="true"
								   :text-field="'name'"
								   :value-field="'id'"
								   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

						<template slot="first">
							<option :value="null" disabled>
								--{{$t('client.create.select-gender')}}--
							</option>
							<option value="MALE">{{$t('client.create.male')}}</option>
							<option value="FEMALE">{{$t('client.create.female')}}</option>
						</template>
					</b-form-select>
				</b-form-group>
			</div>
			<div class="col-sm-6">
				<b-form-group
					label-size="sm"
					label-for="Phone">
					<label class="lebeltop">{{$t('client.create.phone')}}</label>
					<b-form-input size="sm" :placeholder="$t('client.create.phone')" type="text"
								  id="Phone"
								  autocomplete="off"
								  v-model="itemLocalClient.phone"/>
				</b-form-group>
			</div>

			<!--			<div class="col-sm-6" style="margin-left:-4px">-->
			<!--				<b-form-group-->
			<!--					label-size="sm"-->
			<!--					label-for="dismissDate">-->
			<!--					&lt;!&ndash;&ndash;&gt;-->
			<!--					<label class="lebeltop" style="margin-left: 5px">{{$t('client.create.date-of-birth')}}</label>-->
			<!--					<masked-input v-model="itemLocalClient.dateOfBirth"-->
			<!--								  mask="11-11-1111"-->
			<!--								  class="ml-1 form-control form-control-sm"-->
			<!--								  :placeholder=" $t('client.create.date-of-birth')"/>-->
			<!--				</b-form-group>-->
			<!--			</div>-->

		</div>
		<div class="row top">
			<!--			<div class="col-sm-4">-->
			<!--				<b-form-group-->
			<!--					label-size="sm"-->
			<!--					label-for="refName">-->
			<!--					<label class="lebeltop">Tags</label>-->
			<!--					<b-form-input size="sm" placeholder="Tags"-->
			<!--								  type="text"-->
			<!--								  autocomplete="off"-->
			<!--								  id="tags"-->
			<!--								  v-model="itemLocalClient.tags"/>-->
			<!--				</b-form-group>-->
			<!--			</div>-->
			<!--			<div class="col-sm-4">-->
			<!--				<b-form-group-->
			<!--					style="font-size: 12px;padding-top: 3px"-->
			<!--					id="exampleInputGroup3"-->
			<!--					label-for="refCode"-->
			<!--					class="required"-->
			<!--				>-->
			<!--					<label class="lebeltop">-->
			<!--						<span class="redStar">-->
			<!--											*-->
			<!--										</span>{{$t('client.create.gender')}}</label>-->
			<!--					<b-form-select v-model="itemLocalClient.gender"-->
			<!--								   :plain="false"-->
			<!--								   size="sm"-->
			<!--								   :required="true"-->
			<!--								   :text-field="'name'"-->
			<!--								   :value-field="'id'"-->
			<!--								   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">-->

			<!--						<template slot="first">-->
			<!--							<option :value="null" disabled>-->
			<!--								&#45;&#45;{{$t('client.create.select-gender')}}&#45;&#45;-->
			<!--							</option>-->
			<!--							<option value="MALE">Male</option>-->
			<!--							<option value="FEMALE">Female</option>-->
			<!--						</template>-->
			<!--					</b-form-select>-->
			<!--				</b-form-group>-->
			<!--			</div>-->

		</div>
		<!--		<div class="row top">-->
		<!--			<div class="col-sm-4">-->
		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="mobile">-->

		<!--					<label class="lebeltop">{{$t('client.create.mobile')}}</label>-->
		<!--					<b-form-input size="sm" :placeholder="$t('client.create.mobile')" type="text"-->
		<!--								  id="mobile"-->
		<!--								  autocomplete="off"-->
		<!--								  v-model="itemLocalClient.mobile"/>-->
		<!--				</b-form-group>-->
		<!--			</div>-->

		<!--			<div class="col-sm-4">-->
		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="Email"-->
		<!--				>-->

		<!--					<label class="lebeltop">{{$t('client.create.email')}}</label>-->
		<!--					<b-form-input size="sm" :placeholder="$t('client.create.email')" type="text"-->
		<!--								  id="Email"-->
		<!--								  autocomplete="off"-->
		<!--								  v-model="itemLocalClient.email"/>-->
		<!--				</b-form-group>-->
		<!--			</div>-->

		<!--			<div class="col-sm-4">-->
		<!--				<label class="lebeltop">{{$t('client.create.citizen')}}</label>-->
		<!--				<b-form-select v-model="itemLocalClient.citizenId"-->
		<!--							   :plain="false"-->
		<!--							   :options="dropdowns.group.items"-->
		<!--							   size="sm"-->
		<!--							   label-for="Citizen"-->
		<!--							   :required="true"-->
		<!--							   :text-field="'name'"-->
		<!--							   :value-field="'id'"-->
		<!--							   @reload="loadSubCitizen"-->
		<!--				>-->
		<!--					<template slot="first">-->
		<!--						<option :value="null" disabled>&#45;&#45;{{$t('client.create.select-citizen')}}-->
		<!--						</option>-->
		<!--					</template>-->
		<!--				</b-form-select>-->
		<!--			</div>-->


		<!--		</div>-->
		<!--		<div class="row top">-->
		<!--			<div class="col-sm-4">-->
		<!--				<label class="lebeltop">{{$t('client.create.marriage-status')}}</label>-->
		<!--				<b-form-select v-model="itemLocalClient.marriageStatusId"-->
		<!--							   :plain="false"-->
		<!--							   :options="dropdowns.married.items"-->
		<!--							   size="sm"-->
		<!--							   label-for="MarriageStatusName"-->
		<!--							   :required="true"-->
		<!--							   :text-field="'name'"-->
		<!--							   :value-field="'id'"-->
		<!--							   @reload="loadMarried"-->
		<!--				>-->
		<!--					<template slot="first">-->
		<!--						<option :value="null" disabled>&#45;&#45;-->
		<!--							Nikox xolati &#45;&#45;-->
		<!--						</option>-->
		<!--					</template>-->
		<!--				</b-form-select>-->
		<!--			</div>-->


		<!--			<div class="col-sm-4">-->
		<!--				<label class="lebeltop">{{$t('client.create.customer')}}</label>-->
		<!--				<b-form-select v-model="itemLocalClient.customerGroupId"-->
		<!--							   :plain="false"-->
		<!--							   :options="dropdowns.customer.items"-->
		<!--							   size="sm"-->
		<!--							   label-for="Customer"-->
		<!--							   :required="true"-->
		<!--							   :text-field="'name'"-->
		<!--							   :value-field="'id'"-->
		<!--							   @reload="loadCustomerGroup"-->
		<!--				>-->
		<!--					<template slot="first">-->
		<!--						<option :value="null" disabled>&#45;&#45;-->
		<!--							{{$t('client.create.customer')}} &#45;&#45;-->
		<!--						</option>-->
		<!--					</template>-->
		<!--				</b-form-select>-->
		<!--			</div>-->

		<!--			<div class="col-sm-4">-->
		<!--				<label class="lebeltop">{{$t('client.create.category')}}</label>-->
		<!--				<b-form-select v-model="itemLocalClient.categoryId"-->
		<!--							   :plain="false"-->
		<!--							   :options="dropdowns.category.items"-->
		<!--							   size="sm"-->
		<!--							   label-for="CategoryName"-->
		<!--							   :required="true"-->
		<!--							   :text-field="'name'"-->
		<!--							   :value-field="'id'"-->
		<!--							   @reload="loadCategory"-->
		<!--				>-->
		<!--					<template slot="first">-->
		<!--						<option :value="null" disabled>&#45;&#45;-->
		<!--							{{$t('client.create.category')}} &#45;&#45;-->
		<!--						</option>-->
		<!--					</template>-->
		<!--				</b-form-select>-->
		<!--			</div>-->

		<!--		</div>-->
		<!--		<div class="row top" style="margin-top: 2px">-->
		<!--			<div class="col-sm-4">-->
		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="children">-->
		<!--					<label class="lebeltop">{{$t('employees.create.children')}}</label>-->

		<!--					<b-form-input size="sm"-->
		<!--								  :placeholder="$t('employees.create.children')"-->
		<!--								  type="text"-->
		<!--								  autocomplete="off"-->
		<!--								  id="children"-->
		<!--								  v-model="itemLocalClient.children"/>-->
		<!--				</b-form-group>-->
		<!--			</div>-->
		<!--			<div class="col-sm-4" style="margin-top: 25px">-->
		<!--				<b-form-checkbox-->
		<!--					id="checkbox-1"-->
		<!--					v-model="itemLocalClient.conflicted"-->
		<!--					name="checkbox-1"-->

		<!--				>-->
		<!--					Confilicted-->
		<!--				</b-form-checkbox>-->
		<!--			</div>-->

		<!--			<div class="col-sm-4">-->
		<!--				<label class="lebeltop">{{$t('client.create.referal')}}</label>-->
		<!--				<b-form-select v-model="itemLocalClient.referalId"-->
		<!--							   :plain="false"-->
		<!--							   :options="dropdowns.referal.items"-->
		<!--							   size="sm"-->
		<!--							   label-for="ReferalName"-->
		<!--							   :required="true"-->
		<!--							   :text-field="'name'"-->
		<!--							   :value-field="'id'"-->
		<!--							   @reload="loadCategory"-->
		<!--				>-->
		<!--					<template slot="first">-->
		<!--						<option :value="null" disabled>&#45;&#45;-->
		<!--							{{$t('client.create.referal')}} &#45;&#45;-->
		<!--						</option>-->
		<!--					</template>-->
		<!--				</b-form-select>-->
		<!--			</div>-->
		<!--		</div>-->

		<!--		<div class="row top">-->
		<!--			<div class="col-sm-4">-->

		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="refSort">-->
		<!--					<b-row class="my-1">-->
		<!--						<b-col sm="12">-->
		<!--							<label class="lebeltop">{{$t('client.create.address')}}</label>-->
		<!--							<b-form-textarea-->
		<!--								id="refSort"-->
		<!--								size="sm"-->
		<!--								type="text"-->
		<!--								v-model="itemLocalClient.address"-->
		<!--								rows="3"-->
		<!--								max-rows="6"-->
		<!--								:placeholder="$t('client.create.address')"/>-->
		<!--						</b-col>-->
		<!--					</b-row>-->
		<!--				</b-form-group>-->
		<!--			</div>-->

		<!--			<div class="col-sm-4">-->

		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="refSort">-->
		<!--					<b-row class="my-1">-->
		<!--						<b-col sm="12">-->
		<!--							<label class="lebeltop">{{$t('client.create.address-2')}}</label>-->
		<!--							<b-form-textarea-->
		<!--								id="refSort2"-->
		<!--								size="sm"-->
		<!--								type="text"-->
		<!--								v-model="itemLocalClient.address2"-->
		<!--								rows="3"-->
		<!--								max-rows="6"-->
		<!--								:placeholder="$t('client.create.address-2')"/>-->
		<!--						</b-col>-->
		<!--					</b-row>-->
		<!--				</b-form-group>-->
		<!--			</div>-->
		<!--			<div class="col-sm-4">-->
		<!--				<b-form-group-->
		<!--					label-size="sm"-->
		<!--					label-for="refComment">-->
		<!--					<label class="lebeltop">{{$t('comment')}}</label>-->
		<!--					<b-form-textarea-->
		<!--						id="refComment"-->
		<!--						size="sm"-->
		<!--						v-model="itemLocalClient.comment"-->
		<!--						rows="3"-->
		<!--						max-rows="6"-->
		<!--						:placeholder="$t('comment')"/>-->
		<!--				</b-form-group>-->
		<!--			</div>-->


		<!--		</div>-->

		<div class="row top mt-3 justify-content-end">
			<div class="col-3">
				<b-button variant="outline-danger" size="sm" block
						  @click="closeCreateEmployeeModal">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-3">
				<b-button variant="outline-success" size="sm" block @click="saveClientSubmit">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>

	</div>

</template>

<script>
	const itemInitial = {
		id: null,
		firstName: '',
		lastName: '',
		memberCard: '',
		gender: null,
		phone: '',
		// mobile: '',
		// conflicted: false,

		// memberCardDiscount: '',
		// referalId: null,
		// referalName: '',
		// categoryId: null,
		// categoryName: '',
		// customerGroupId: null,
		// customerGroupName: '',
		// tags: '',

		// middleName: null,
		// dateOfBirth: '',

		// email: '',
		// address: null,
		// address2: '',
		// citizenId: null,
		// citizenName: '',
		// marriageStatusId: null,
		// marriageStatusName: '',
		// hireDate: null,
		// dropdowns: {
		// 	group: {
		// 		items: [],
		// 		value: null,
		// 	},

		// }


	};
	import {mapActions, mapGetters, mapState} from 'vuex';
	import MaskedInput from 'vue-masked-input';


	export default {
		components: {
			MaskedInput,
		},
		props: {
			updateObj: {
				type: Object,
				default: () => null
			},
			mode: {
				type: String,
				default: "create"
			}
		},
		data() {
			return {
				isValid: '',
				currentPage: 1,
				perPage: 20,
				refInputNotFilled: false,
				itemLocalClient: {
					id: null,
					firstName: '',
					lastName: '',
					memberCard: '',
					gender: null,
					phone: '',
					// memberCardDiscount: '',
					// middleName: '',
					// dateOfBirth: null,
					// tags: '',

					// mobile: '',
					// email: '',
					// address: '',
					// address2: '',
					// conflicted: false,
					// referalId: null,
					// referalName: '',
					// categoryId: null,
					// categoryName: '',
					// customerGroupId: null,
					// customerGroupName: '',
					// citizenId: null,
					// citizenName: '',
					// marriageStatusId: null,
					// marriageStatusName: '',
					// comment: '',
					// children: ''


				},
				// dropdowns: {
				// 	group: {
				// 		items: [],
				// 		value: null,
				// 	},
				// 	married: {
				// 		items: [],
				// 		value: null,
				// 	},
				//
				// 	customer: {
				// 		items: [],
				// 		value: null,
				// 	},
				// 	category: {
				// 		items: [],
				// 		value: null,
				// 	},
				// 	referal: {
				// 		items: [],
				// 		value: null,
				// 	}
				// },
			}
		},


		methods: {
			...mapActions('clients', [
				'saveClientStore', 'getAllClientsForTable', 'generateMemberCardStore', 'saveClientItemForPos', 'emptyOjbectClientFromModalSidebar'
			]),

			async saveClientSubmit() {

				if (this.itemLocalClient.firstName != '' && this.itemLocalClient.lastName != '' && this.itemLocalClient.memberCard != '') {
					await this.saveClientStore(this.itemLocalClient);
					await this.saveClientItemForPos(this.itemLocalClient);
					let paramsForUsers = {
						page: this.currentPage,
						limit: this.perPage
					};
					await this.getAllClientsForTable(paramsForUsers);
//					const emptyObject = {};
//					await this.emptyOjbectClientFromModalSidebar(emptyObject);

					this.$emit('close', true);
				} else {
					this.isValid = false;
					this.refInputNotFilled = true;
				}
			},

			async generateMemberCardFunc() {
				this.itemLocalClient.memberCard = this.generateMemberCardObject;
				this.isValid = true
			},

			// loadSubCitizen() {
			// 	ReferencesService.getReferenceChildren(`Citizen`).then(response => {
			// 		this.dropdowns.group.items = response.data;
			// 	})
			// },
			// loadMarried() {
			// 	ReferencesService.getReferenceChildren(`Marriage_status`).then(response => {
			// 		this.dropdowns.married.items = response.data;
			//
			// 	})
			// },
			// loadCustomerGroup() {
			// 	ReferencesService.getReferenceChildren('Customer').then(response => {
			// 		this.dropdowns.customer.items = response.data;
			// 	})
			// },
			// loadCategory() {
			// 	ReferencesService.getReferenceChildren('Category').then(response => {
			// 		this.dropdowns.category.items = response.data;
			// 	})
			// },
			// loadReferal() {
			// 	ReferencesService.getReferenceChildren('Referal').then(response => {
			// 		this.dropdowns.referal.items = response.data;
			// 	})
			// },

			isNumber: function (evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
					evt.preventDefault();

				} else {
					return true;
				}
			},
			async closeCreateEmployeeModal() {
				this.itemLocalClient = await itemInitial;
				this.$emit('close', true);

			},
			cancel() {
				this.$emit('close', true);
			},


		},
		computed: {
			item: {
				get() {
					return this.itemLocalClient;
				},
				set(data) {
					this.itemLocalClient = data;
				},
			},
			...mapGetters('clients', [
				'generatedMemberCard'
			]),
			...mapState('clients', [
				'generateMemberCardObject', 'updateSidebarOneClient'
			]),
		},
		async mounted() {
			if (this.mode == "create") {
				this.itemLocalClient = Object.assign({}, itemInitial);
				this.itemLocalClient.phone = '998'
			} else {
				this.itemLocalClient = this.updateSidebarOneClient;
			}
			this.$refs.clientNameRef.focus();
			// await this.loadSubCitizen();
			// await this.loadMarried();
			// await this.loadCustomerGroup();
			// await this.loadCategory();
			// await this.loadReferal();
		},
		created() {
			this.generateMemberCardStore();
		},
		watch: {
			'dropdowns.group.value': {
				handler() {
					if (this.dropdowns.value)
						return;
					this.dropdowns.group.items.map((citizen) => {
						if (citizen.id === this.dropdowns.group.value) {
							this.itemLocalClient.citizenId = citizen.id;
						}
						return true;
					});
				}
			},
		}


	}
</script>

<style scoped>
	.row {
		margin-top: -9px;
	}

	.lebeltop {
		font-size: 12px;
	}

	label {
		margin-bottom: 0px;
	}

	.redStar {
		color: red;
	}

</style>
